import {TranslationObject} from '@colonist/i18n'
import {GameColor} from '../GameColor'
import {SectionView} from './SectionView'
import {SpriteView} from './SpriteView'
import {TextView} from './TextView'
import {PIXI} from '@colonist/pixi'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {GameFont} from '../GameFont'

export class NotificationCounterView extends SectionView {
    private readonly notificationCircle: SpriteView
    private readonly countText: TextView

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container) {
        super(x, y, w, h, container)

        const redCircleTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.red_circle)
        this.notificationCircle = new SpriteView(0, 0, this.width, this.height, this, redCircleTexture)

        const initialCount: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: '0'}}
        this.countText = new TextView(initialCount, 0, 0, this.width, this.height, this)

        const fontSize = this.height * 0.75

        this.countText.changeStyle({
            fontSize: fontSize,
            fontWeight: GameFont.Weight.Bold,
            fill: GameColor.getColor(GameColor.Color.OffWhite),
            stroke: GameColor.getColor(GameColor.Color.DarkGrey),
            strokeThickness: 2,
            trim: false,
            wordWrap: false,
        })

        this.countText.centerXInParent()
        this.countText.repositionY(true)
    }

    updateCount(count: number) {
        this.countText.setText({key: 'strings:colonistCommon.utils.#buffer', options: {value: count}})
        this.countText.centerXInParent()
        this.countText.repositionY(true)
    }

    setNeutralNotificationTexture() {
        const greyCircleTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.grey_circle)
        this.notificationCircle.texture = greyCircleTexture
    }

    setWinningNotificationTexture() {
        const greenCircleTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.green_circle)
        this.notificationCircle.texture = greenCircleTexture
    }

    setLosingNotificationTexture() {
        const redCircleTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.red_circle)
        this.notificationCircle.texture = redCircleTexture
    }
}
